<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'
import SelectsLEx from '@components/localExpenses/SelectsLEx'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'
import AddLocalCharge from '@components/localExpenses/AddLocalCharge'
import EditDateRange from '@components/localExpenses/EditDateRange'
import MultiDuplicates from '@components/localExpenses/MultiDuplicates'
import EditLocalCharge from '@components/localExpenses/EditLocalCharge'
import DuplicatedLocalCharge from '@components/localExpenses/DuplicatedLocalCharge'
import { Component } from '@fullcalendar/core'

export default {
  page: {
    title: 'Local Charges General',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    SelectsLEx,
    HideColumnsTable,
    AddLocalCharge,
    EditDateRange,
    MultiDuplicates,
    EditLocalCharge,
    DuplicatedLocalCharge,
  },
  data() {
    return {
      title: 'Local Charges',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Local Charges',
          href: '/local_charges',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      filterOn: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [],
      fieldList: [
        { key: 'id', label: 'ID', sortable: true, checkBox: true },
        {
          key: 'company_user',
          label: 'Company',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'origin',
          label: 'Origin Port',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'destiny',
          label: 'Destination Port',
          sortable: true,
          checkBox: true,
        },
        { key: 'charge', label: 'Charge Type', sortable: true, checkBox: true },
        {
          key: 'typedestiny',
          label: 'Type Destiny',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'calculation_type',
          label: 'Calculation Type',
          sortable: true,
          checkBox: true,
        },
        { key: 'currency', label: 'Currency', sortable: true, checkBox: true },
        { key: 'carriers', label: 'Carriers', sortable: true, checkBox: true },
        {
          key: 'amount',
          label: 'Amount',
          sortable: true,
          checkBox: true,
        },
        { key: 'validity', label: 'Validity', sortable: true, checkBox: true },
        {
          key: 'info',
          label: 'More Information',
          sortable: true,
          checkBox: true,
        },
        { key: 'actions', label: 'Options', checkBox: false },
      ],
      filteredData: [],
      excludeFields: [],
      typeTable: 'LocalExpensesListFCL',
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      loadingData: false,
      loadingTable: true,
      showModal: false,
      company_user_id: null,
      carrier_id: null,
      selectedAll: false,
      loandingTableSelects: true,
      idLocal: null,
      idsSelected: [],
      dataModel: {
        add: {
          title: 'Add Local Charge',
          component: 'AddLocalCharge',
        },
        editDateRange: {
          title: 'Edit Date Local Charge',
          component: 'EditDateRange',
        },
        multiDuplicates: {
          title: 'MultiDuplicates Local Charge',
          component: 'MultiDuplicates',
        },
        edit: {
          title: 'Edit Local Charge',
          component: 'EditLocalCharge',
        },
        duplicate: {
          title: 'Duplicate Local Charge',
          component: 'DuplicatedLocalCharge',
        },
      },
    }
  },
  watch: {
    filter(newValue) {
      localStorage.setItem('searchLocalChargeFcl', newValue)
    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
    computedFilter: function() {
      if (this.filter === null) {
        return null
      }
      return [this.filter]
    },
  },
  created() {
    this.totalRows = this.tableData.length
  },
  mounted() {
    // Set the initial number of items

    const searchValue = localStorage.getItem('searchLocalChargeFcl')
    if (searchValue) {
      this.filter = searchValue
    }
  },
  destroyed() {},
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.filteredData = filteredItems
    },
    customFilterTable(row, filter) {
      const baseFilter = filter[0].trim()
      let rowVar = { ...row }
      let valuesRow = Object.values(rowVar)
      let filtersSp = baseFilter.split(' ')
      const filtersFined = []

      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          let valRowLC = String(valRow).toLowerCase()
          let filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })
      return filtersFined.length === filtersSp.length
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
    getData() {
      this.loadingTable = true
      axiosGetPost(
        'post',
        '/localCharges/listLocalCharges',
        {
          company_user: this.company_user_id,
          carrier: this.carrier_id,
        },
        'Load List Local Chargers by company and carrier FCL'
      ).then((response) => {
        const data = response.data
        if (response.success) {
          this.tableData = data
          this.loadingTable = false
        } else {
          this.$toastr.e('Error')
        }
        return data
      })
    },
    findIndex(id) {
      var valObj = this.tableData.findIndex(function(elem) {
        if (elem.id === id) return elem
      })
      return valObj
    },
    saveModal() {
      this.showModal = false
    },
    loadValuesSelects(carrier, companyUser) {
      this.carrier_id = carrier
      this.company_user_id = companyUser
      this.getData()
    },
    getCheckboxStyle(item) {
      if (item.exeptions_origin || item.exeptions_destiny) {
        // Si hay información en 'origen' o 'destino', aplica el estilo personalizado
        return {
          backgroundColor: 'green', // Cambia el color de fondo del checkbox
          color: 'white', // Cambia el color del ícono del checkbox
        }
      } else {
        // Si no hay información en 'origen' ni en 'destino', no aplica ningún estilo personalizado
        return {}
      }
    },
    getElementsTable() {
      let ids = []
      this.tableData.forEach((element, index) => {
        if (element.checked === true) {
          ids.push(element['id'])
        }
      })
      if (ids.length == 0) {
        this.$toastr.e(
          'Attention. Error. You have to select 1 or more elements'
        )
        return []
      }
      return ids
    },
    deleteRows(ids) {
      this.$swal({
        title:
          'Are you sure you want to remove those IDs? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.$toastr.i('In Process. Deleting Local chargers')
          axiosGetPost(
            'post',
            '/localCharges/deleteGeneralLocals',
            {
              localcharger_ids: ids,
            },
            'MultiDelete Local Charge FCL'
          ).then((response) => {
            if (response.success) {
              this.$toastr.s('Sucess. Local chargers Deleted')
            } else {
              this.$toastr.e('Attention. Error')
            }
            this.getData()
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    selectMultipleDelete() {
      let ids = this.getElementsTable()
      if (ids.length >= 1) {
        this.deleteRows(ids)
      }
    },
    selectUnselect() {
      this.loandingTableSelects = false
      this.selectedAll = !this.selectedAll ? true : false
      let data =
        this.filteredData.length >= 1 ? this.filteredData : this.tableData
      data.map((a) => (a.checked = this.selectedAll))
      this.loandingTableSelects = true
    },
    openModal(key) {
      this.modalTitle = this.dataModel[key].title
      this.modalComponent = this.dataModel[key].component
      this.showModal = true
    },
    updateTable() {
      this.saveModal()
      this.getData()
    },
    editLocal(id) {
      this.idLocal = id
      this.openModal('edit')
    },
    duplicateLocal(id) {
      this.idLocal = id
      this.openModal('duplicate')
    },
    selectAction(module = 'editDateRange') {
      this.idsSelected = []
      let ids = this.getElementsTable()
      if (ids.length >= 1) {
        this.idsSelected = ids
        let openModule = module == 'editDateRange' ? 'editDateRange' : module
        this.openModal(openModule)
      }
    },
    deleteItem(idLocal) {
      this.deleteRows([idLocal])
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Local Charges</h4>
              </div>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-7 col-md-7 text-md-left">
                <SelectsLEx @load-values="loadValuesSelects" />
              </div>
              <div class="col-sm-5 col-md-5 text-md-right">
                <button
                  class="btn my-2 btn-outline-primary col-sm-3"
                  title="Multiple Edition"
                  @click="openModal('add')"
                >
                  Add &nbsp; <i class="uil uil-plus"></i> </button
                >&nbsp;
                <button
                  class="btn my-2 btn-outline-primary"
                  title="Multiple Edition"
                  @click="selectMultipleDelete()"
                >
                  Multiple Delete &nbsp; <i class="uil uil-edit"></i> </button
                >&nbsp;
                <button
                  class="btn my-2 btn-outline-primary"
                  title="Multiple Edition"
                  @click="selectAction()"
                >
                  Edit Date Selected &nbsp;
                  <i class="uil uil-edit"></i> </button
                >&nbsp;
                <button
                  class="btn my-2 btn-outline-primary"
                  title="Multiple Edition"
                  @click="selectAction('multiDuplicates')"
                >
                  Duplicate Selected &nbsp; <i class="uil uil-edit"></i>
                </button>
              </div>
            </div>

            &nbsp;

            <div class="d-flex mb-md-2">
              <div class="mr-auto">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Multiple Edition"
                  @click="selectUnselect()"
                  >Select All / Unselect &nbsp;
                  <i class="uil uil-check"></i> </button
                >&nbsp;
              </div>
              <div>
                <HideColumnsTable
                  :field-list-fth="fieldList"
                  :type-table="typeTable"
                  @updateTableFieldsEmit="updateTableFieldsEmit"
                />
              </div>
              <!-- Search -->
              <div>
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-if="loandingTableSelects">
              <div class="table-responsive mb-0 table-responsive-list-menu">
                <b-table
                  striped
                  hover
                  :items="tableData"
                  :fields="fields"
                  :busy="loadingTable"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="computedFilter"
                  :filter-included-fields="filterOn"
                  :filter-function="customFilterTable"
                  @filtered="onFiltered"
                >
                  <template v-slot:table-busy>
                    <div
                      class="row align-items-center justify-content-center"
                      style="height: 150px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <div v-if="company_user_id">
                          <b-spinner
                            label="Loading..."
                            variant="primary"
                            class="ml-3"
                          ></b-spinner>
                        </div>
                        <div v-else>
                          <h4> Select a Company </h4>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(id)="row">
                    <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                    <b-form-checkbox v-model="row.item.checked">
                      {{ row.item.id }}
                    </b-form-checkbox>
                  </template>
                  <template v-slot:cell(info)="row">
                    <td class="custom-checkbox-cell">
                      <b-form-checkbox
                        v-model="row.detailsShowing"
                        @change="row.toggleDetails"
                      >
                      </b-form-checkbox>
                      <div
                        class="checkbox-wrapper"
                        :style="getCheckboxStyle(row.item)"
                      >
                      </div>
                    </td>
                  </template>
                  <template #row-details="row">
                    <b-card class="custom-card">
                      <b-row>
                        <b-col sm="2" class="text-sm-left"
                          ><b>Exceptions at origin:</b></b-col
                        >
                        <span v-if="row.item.exeptions_origin">
                          {{ row.item.exeptions_origin }}
                        </span>
                        <span v-else> No exceptions </span>
                      </b-row>
                      <b-row>
                        <b-col sm="2" class="text-sm-left"
                          ><b>Exceptions at destination:</b></b-col
                        >
                        <span v-if="row.item.exeptions_destiny">
                          {{ row.item.exeptions_destiny }}
                        </span>
                        <span v-else> No exceptions </span>
                      </b-row>
                    </b-card>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div>
                      <b-dropdown
                        variant="success"
                        dropleft
                        class="ml-1 btn-sm"
                        :ref="`actions_dropdown_${row.item.id}`"
                      >
                        <template slot="button-content">
                          <i
                            class="uil uil-angle-double-left"
                            style="color: #278c27"
                          ></i>
                          <i>Options</i>
                        </template>
                        <div>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="editLocal(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-edit"></i>
                              &nbsp; Edit
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="duplicateLocal(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-file-copy-alt"></i>
                              &nbsp; Duplicate
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="deleteItem(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-trash"></i>
                              &nbsp; Delete
                            </span>
                          </b-dropdown-item>
                        </div>
                      </b-dropdown>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>Filtered {{ totalRows }} of {{ rows }} entries</strong>
                <div
                  class="dataTables_paginate paging_simple_numbers float-lefts"
                >
                  <span>
                    <!--<i>Total Rows: {{ rows }}</i>-->
                  </span>
                </div>
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Cambio de status -->
      <!-- <b-button variant="success" @click="test">methods</b-button> -->
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <AddLocalCharge
          v-if="modalComponent === 'AddLocalCharge'"
          @closeModal="updateTable"
        />
        <EditDateRange
          v-if="modalComponent === 'EditDateRange'"
          :ids-seleted="idsSelected"
          @closeModal="updateTable"
        />
        <MultiDuplicates
          v-if="modalComponent === 'MultiDuplicates'"
          :ids-seleted="idsSelected"
          @closeModal="updateTable"
        />
        <EditLocalCharge
          v-if="modalComponent === 'EditLocalCharge'"
          :local-id="idLocal"
          @closeModal="updateTable"
        />
        <DuplicatedLocalCharge
          v-if="modalComponent === 'DuplicatedLocalCharge'"
          :local-id="idLocal"
          @closeModal="updateTable"
        />

        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <!--
          <b-button
            v-if="loadingData === false"
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>-->
        </template>
      </b-modal>
    </div>
  </Layout>
</template>

<style>
.custom-card {
  max-height: 80px; /* Ajusta la altura máxima del b-card */
  margin: 0 auto; /* Centra el b-card en su contenedor */
  padding: 0rem; /* Ajusta el espacio interior del b-card */
  /*overflow: auto;    /* Agrega barras de desplazamiento si el contenido excede la altura máxima */
}

.custom-checkbox-cell {
  display: flex; /* Habilita el uso de Flexbox */
  justify-content: center; /* Centra el contenido horizontalmente */
  align-items: center; /* Centra el contenido verticalmente */
}

.checkbox-wrapper {
  border-radius: 60%; /* Hace que el fondo sea circular */
  padding: 4px; /* Espacio entre el borde del fondo y el checkbox */
}

.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
